'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ChatRichTemplateMetadata = require('../../records/PubNubMessageMetadata/chat-rich-template/ChatRichTemplateMetadata');

var _ChatRichTemplateMetadata2 = _interopRequireDefault(_ChatRichTemplateMetadata);

var _Button = require('../../records/PubNubMessageMetadata/chat-rich-template/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Template = require('../../records/PubNubMessageMetadata/chat-rich-template/Template');

var _Template2 = _interopRequireDefault(_Template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTemplateFromMetaData = function createTemplateFromMetaData(template) {
  var data = template.set('templateButtons', template.get('templateButtons').map(function (button) {
    return new _Button2.default(button);
  }));
  return (0, _Template2.default)(data);
};

var buildChatRichTemplate = function buildChatRichTemplate() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var metaData = (0, _immutable.fromJS)(props);
  var data = metaData.merge({
    richMediaTemplates: metaData.get('richMediaTemplates').map(function (template) {
      return createTemplateFromMetaData(template);
    })
  });
  return (0, _ChatRichTemplateMetadata2.default)(data);
};
exports.default = buildChatRichTemplate;
module.exports = exports['default'];